import React from 'react';
import History from '../../components/Stats/History';

function HistoryScene() {
  return (
    <div>
      <History title="All time history" />
    </div>
  );
}

export default HistoryScene;
